exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table td{vertical-align:middle}.text-gold{color:#fcb307}.btn[disabled]{cursor:not-allowed}", ""]);

// exports
